export default "<mat-divider></mat-divider>\r\n<footer>\r\n    &copy; All rights reserved 2019\r\n</footer>"